import { type AuthUser } from "wasp/auth";
import DefaultLayout from "../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../useRedirectHomeUnlessUserIsAdmin";
import { useEffect, useState } from "react";
import setDocumentTitle from "../../setDocumentTitle";
import JobsEmptyView from "../../views/JobsView/JobsEmptyView";
import JobsView from "../../views/JobsView/JobsView";
import { getEnrichmentTasks, useQuery } from "wasp/client/operations";
import type { EnrichmentJob } from "wasp/entities";
import { Loader2 } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useTranslation } from "../../i18n/hooks";

const AdminDashboardPage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });
  const { t } = useTranslation();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const {data: enrichmentTasks, isLoading: isInitialLoading} = useQuery(getEnrichmentTasks, { collectionId: currentUser?.currentCollectionId ?? "" });
  
  useEffect(() => {
    setDocumentTitle(t('sidebar.jobs'));
  }, [])

  const hasJobs = enrichmentTasks && enrichmentTasks?.length > 0;

  return (
    <DefaultLayout user={user}   useWideLayout={true}       rightSidebarContent={null}
>       <div className="w-full max-w-full">

      {isInitialLoading ? (
        <Loader2 className="w-6 h-6 animate-spin" />
      ) : !hasJobs ? (
        <JobsEmptyView />
      ) : (
        <JobsView jobs={enrichmentTasks}/>
      )}  </div>
    </DefaultLayout>
  );
};

export default AdminDashboardPage;
